import React, { useState, useEffect, useMemo } from "react";
import calendar from "../../PicesForPages/calendar-5.png";
import smartphoneHand from "../../PicesForPages/smartphone-7.png";
import smartphoneVoice from "../../PicesForPages/smartphone-6.png";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";
import ChatBotPurchase from "../Form/ChatBotPurchase";
import ChatBotRefinance from "../Form/ChatBotRefinance";
import Video_2 from "../../PicesForPages/Video_2.mov";
import "./2.css";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import ClientReview from "../Client_Review/clientReview";

function Home2() {
  const texts = useMemo(
    () => [
      "Reduce Your Payment",
      "Secure a Better Rate",
      "Own Your First Home",
      "Get Your Dream Home",
      "Access Your Equity",
    ],
    [],
  );

  const [currentText, setCurrentText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeChatBot, setActiveChatBot] = useState(null); // null, "purchase", or "refinance"
  const typingSpeed = 100;
  const deletingSpeed = 50;

  useEffect(() => {
    const handleTyping = () => {
      const fullText = texts[currentTextIndex];

      if (!isDeleting) {
        setCurrentText((prev) => fullText.substring(0, prev.length + 1));
        if (currentText === fullText) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        setCurrentText((prev) => fullText.substring(0, prev.length - 1));
        if (currentText === "") {
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    };

    const typingInterval = setInterval(
      handleTyping,
      isDeleting ? deletingSpeed : typingSpeed,
    );

    return () => clearInterval(typingInterval);
  }, [currentText, isDeleting, texts, currentTextIndex]);

  const location = useLocation();

  // useEffect(() => {
  //   if (location.hash) {
  //     const element = document.getElementById(location.hash.substring(1));
  //     if (element) {
  //       element.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }
  // }, [location]);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        const elementTop =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offset = 100;
        window.scrollTo({
          top: elementTop - offset,
          behavior: "smooth",
        });
      }
    }
  }, [location]);

  return (
    <div className="homeParent">
      <div className="homeHelpYouBoxParent homeHelpYouBoxParent2">
        {/* <div className="homeHelpYouBoxVideoBox homeHelpYouBoxVideoBox2">
          <video
            className="homeHelpYouBoxVideo homeHelpYouBoxVideo2"
            autoPlay
            loop
            muted
          >
            <source src={Video_2} type="video/mp4" />
            <source src={Video_2.replace(".mp4", ".webm")} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div> */}
        <div className="homeHelpYouBoxVideoBox homeHelpYouBoxVideoBox2">
          <div className="homeHelpYouOverlay" />
          <video
            className="homeHelpYouBoxVideo homeHelpYouBoxVideo2"
            autoPlay
            loop
            muted
          >
            <source src={Video_2} type="video/mp4" />
            <source src={Video_2.replace(".mp4", ".webm")} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="homeHelpYouBox homeHelpYouBox2">
          {activeChatBot === null && (
            <>
              <span className="homeHelpYouHeading homeHelpYouHeading2">
                <span className="homeHelpYouHeadingLeft homeHelpYouHeadingLeft2">
                  Let's Assist You...{" "}
                </span>
                <span className="typingText homeHelpYouHeadingRight">
                  {currentText}
                </span>
              </span>
              <span className="homeHelpYouContent homeHelpYouContenttext">
                Whatever your objectives are, <br /> we're here to support you!{" "}
                <br />
                Click our prequalifier to begin today!
              </span>
              {/* <span className="homeHelpYouButton">
                <button
                  className="homeHelpYouButtonLeft"
                  onClick={() => setActiveChatBot("purchase")}
                >
                  Purchase
                </button>
                <button
                  className="homeHelpYouButtonRight"
                  onClick={() => setActiveChatBot("refinance")}
                >
                  Refinance
                </button>
              </span> */}
              <span className="homeHelpYouButton homeHelpYouButton01">
                <button
                  className="homeHelpYouButtonMP_Link"
                  onClick={() => setActiveChatBot("Pre-Qualify")}
                >
                  Pre-Qualify
                </button>
                <Link to="/todays-rates" className="homeHelpYouButtonMP_Link01">
                  Today’s Rates
                </Link>
              </span>
            </>
          )}

          {activeChatBot === "Pre-Qualify" && (
            <span className="homeHelpYouChatBot">
              <span className="homeHelpYouButton ChartBotBothBox">
                <span className="ChartBotForm ChartBotFormButtons">
                  <button
                    className="homeHelpYouButtonLeft"
                    onClick={() => setActiveChatBot("purchase")}
                  >
                    Purchase
                  </button>
                  <button
                    className="homeHelpYouButtonRight"
                    onClick={() => setActiveChatBot("refinance")}
                  >
                    Refinance
                  </button>
                </span>
              </span>
              <button
                className="closebtnChatBot closebtnChatBotButtons"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}

          {activeChatBot === "purchase" && (
            <span className="homeHelpYouChatBot">
              <ChatBotPurchase />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}

          {activeChatBot === "refinance" && (
            <span className="homeHelpYouChatBot">
              <ChatBotRefinance />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}
        </div>
      </div>
      {/* <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Welcome to <span className="logoBoldColor">The Mortgageist</span>.
          </span>
          <span className="welcomeContent">
            Welcome to <span className="logoBoldColor">The Mortgageist</span>,
            where expertise meets personalized service in home financing. We
            simplify mortgages, guiding you through the process with clarity and
            support. Securing the right mortgage is crucial for building lasting
            memories in your new home. We tailor our approach to each client's
            unique needs and goals, offering competitive loan options and market
            insights. Whether you're a first-time buyer or refinancing, we help
            turn your homeownership dreams into reality.
          </span>
        </div>
      </div> */}
      <div className="advantageBoxParent">
        <div className="advantageBox">
          <div className="advantageHeading">
            <span className="logoBoldColor">The Mortgageist</span> Provides
          </div>
          <div className="advantageContentBoxParent">
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={calendar}
                  alt="calender"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Quick Turnaround
              </span>
              <span className="advantageContentBoxContent">
                We stive to finalize your loan swiftly. We closed 99.9% of the
                loans in 30 days and 75% of the loans in 21 days. And do you
                have a challenging timeline? Let us know, we are here to help
                and make it happen.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneHand}
                  alt="smartphoneHand"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Exceptional Support
              </span>
              <span className="advantageContentBoxContent">
                We are ever available and eager to support. We are available on
                call, WhatsApp, SMS or email. Our team always believes that you
                should know where you are spending your hard-earned money.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneVoice}
                  alt="smartphoneVoice"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Continuous Innovation
              </span>
              <span className="advantageContentBoxContent">
                We like to make thigs easy. Loan processing need not be
                stressful. We embrace technology and always innovating and
                streamlining our processes with the most current technology.
              </span>
            </span>
          </div>
        </div>
      </div>

      <div id="client-reviews"></div>
      <ClientReview />
      <div id="client_reviews"></div>

      <MortgageCalculator />

      <BlogPostInAPage />
      <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Texas Consumer Complaint Notice
          </span>
          <span className="welcomeContent">
            TEXAS RESIDENTS: CONSUMERS WISHING TO FILE A COMPLAINT AGAINST A
            MORTGAGE COMPANY OR RESIDENTIAL MORTGAGE LOAN ORIGINATOR LICENSED IN
            TEXAS SHOULD SEND A COMPLETED COMPLAINT FORM TO THE DEPARTMENT OF
            SAVINGS AND MORTGAGE LENDING (SML): 2601 N. LAMAR BLVD., SUITE 201,
            AUSTIN, TEXAS 78705; {/* <b>TEL: 1-877-276-5550</b> */}
            <a href="tel:+1-877-276-5550" style={{ color: "black" }}>
              {/* <i className="ri-phone-fill"></i> */}
              <i>TEL: 1-877-276-5550</i>
            </a>
            . INFORMATION AND FORMS ARE AVAILABLE ON{" "}
            <a
              href="https://www.sml.texas.gov/"
              target="_blank"
              rel="noreferrer"
              style={{ color: "black" }}
            >
              <i>SML'S WEBSITE: SML.TEXAS.GOV</i>
            </a>
            .
          </span>
        </div>
      </div>
    </div>
  );
}

export default Home2;
